import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ScrollService {
    timeout: any = null;
    constructor() {}

    scrollTo(id: string): void {
        window.clearTimeout(this.timeout);
        this.timeout = window.setTimeout(() => {
            document.getElementById(id).scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
        }, 100);
    }
}

